import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-note-confirmation-dialog',
  templateUrl: './note-confirmation-dialog.component.html',
  styleUrls: ['./note-confirmation-dialog.component.scss'],
})
export class NoteConfirmationDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<NoteConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  ) {}

  ngOnInit(): void {}

  onConfirm() {
    this.dialogRef.close(true); // Return true when user confirms
  }

  onCancel() {
    this.dialogRef.close(false); // Return false when user cancels
  }
}
